const ProjectFooter = () => {

    return(
        <div className="w-full">
            <div className="w-full rounded-t-xl dark:bg-white bg-black dark:text-black text-white text-3xl md:text-5xl lg:text-7xl xl:text-9xl p-4 md:p-12 xl:p-16 flex font-medium">
                <span>WHERE <br/> FOURTY <br/> IS STILL <br/> WRITTEN <br/> AS IT <br/> SHOULD <br/> BE.</span>
            </div>
            {/* <div className="flex">
                <div className={`dark:bg-white bg-black w-[10%]`} style={{height: Math.floor(window.innerHeight *0.7)}}></div>
                <img className="w-4/5 object-contain" src={"/background/super_high_qual/website backdrop webp/weebsite backdrop0001.webp"} style={{height: Math.floor(window.innerHeight *0.7)}} />
                <div className={`dark:bg-white bg-black w-[10%]`} style={{height: Math.floor(window.innerHeight *0.7)}}></div>
            </div> */}
            <div className="w-full py-8 flex-1 dark:bg-white bg-black text-2xl md:text-3xl lg:text-5xl xl:text-7xl dark:text-black text-white text-center font-medium md:py-16 uppercase" id="contact">
                <a href="mailto:hello@archive42.at" className="h-full w-full flex justify-center items-center hover:underline hover:cursor-cur_hover active:cursor-fancyactive_b">
                    hello@archive42.at
                </a>
            </div>        
        </div>
    )
}

export default ProjectFooter